"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitcoinPrivateKeyUtils = exports.BitcoinPublicKeyUtils = void 0;
const ethers_1 = require("ethers");
const ecpair_1 = require("ecpair");
const tinysecp = __importStar(require("@bitcoinerlab/secp256k1"));
const network_1 = require("./network");
/**
 * Checks whether given public key is a compressed Bitcoin public key.
 * @param publicKey - Public key that should be checked.
 * @returns True if the key is a compressed Bitcoin public key, false otherwise.
 */
function isCompressedPublicKey(publicKey) {
    const publicKeyStr = publicKey.toString();
    // Must have 33 bytes and 02 or 03 prefix.
    return (publicKeyStr.length == 66 &&
        (publicKeyStr.substring(0, 2) == "02" ||
            publicKeyStr.substring(0, 2) == "03"));
}
/**
 * Compresses the given uncompressed Bitcoin public key.
 * @param publicKey Uncompressed 64-byte public key.
 * @returns Compressed 33-byte public key prefixed with 02 or 03.
 */
function compressPublicKey(publicKey) {
    const publicKeyStr = publicKey.toString();
    // Must have 64 bytes and no prefix.
    if (publicKeyStr.length != 128) {
        throw new Error("The public key parameter must be 64-byte. Neither 0x nor 04 prefix is allowed");
    }
    // The X coordinate is the first 32 bytes.
    const publicKeyX = publicKeyStr.substring(0, 64);
    // The Y coordinate is the next 32 bytes.
    const publicKeyY = publicKeyStr.substring(64);
    const prefix = ethers_1.BigNumber.from(`0x${publicKeyY}`).mod(2).eq(0) ? "02" : "03";
    return `${prefix}${publicKeyX}`;
}
/**
 * Utility functions allowing to perform operations on Bitcoin ECDSA public keys.
 */
exports.BitcoinPublicKeyUtils = {
    isCompressedPublicKey,
    compressPublicKey,
};
/**
 * Creates a Bitcoin key pair based on the given private key.
 * @param privateKey Private key that should be used to create the key pair.
 *                   Should be passed in the WIF format.
 * @param bitcoinNetwork Bitcoin network the given key pair is relevant for.
 * @returns Bitcoin key pair.
 */
function createKeyPair(privateKey, bitcoinNetwork) {
    // eslint-disable-next-line new-cap
    return (0, ecpair_1.ECPairFactory)(tinysecp).fromWIF(privateKey, (0, network_1.toBitcoinJsLibNetwork)(bitcoinNetwork));
}
/**
 * Utility functions allowing to perform operations on Bitcoin ECDSA private keys.
 */
exports.BitcoinPrivateKeyUtils = {
    createKeyPair,
};
//# sourceMappingURL=ecdsa-key.js.map